export enum Pagina {

    'Órgãos' = '/orgaos',
    'Usuários' = '/usuarios',
    'Setores' = '/setores',
    'Agendamentos' = '/agendamentos',
    'Parâmetros de E-mail' = '/parametros-email',
    'Relatórios Personalizados' = '/relatorios-personalizados',
    'Exercícios' = '/exercicios',
    'Assinaturas' = '/assinaturas',
    'Auditoria' = '/auditoria',

    'Estoques' = '/estoques',
    'Grupos de Estoque' = '/grupos-estoque',
    'Unidades de Fornecimento' = '/unidades-fornecimento',
    'Subgrupos de Estoque' = '/subgrupos-estoque',
    'Materiais' = '/materiais',
    'Entradas' = '/entradas',
    'Saídas' = '/saidas',

    'Processos' = '/processos',
    'Fiscalizações' = '/fiscalizacoes',
    'Questionários' = '/questionarios',
    'Auditoria de Empenhos' = '/auditoria-empenhos',
    'Auditoria de Adiantamentos' = '/auditoria-adiantamentos',
    'Auditoria de Contratos' = '/auditoria-contratos',
    'Auditoria de Licitações' = '/auditoria-licitacoes',
    'Auditoria de Avaliações' = '/auditoria-avaliacoes',
    'Auditoria de Patrimônios' = '/auditoria-patrimonios',
    'Audesp-TCE-SP' = '/importar-audesp',

    'Contratos' = '/contratos',
    'Favorecidos' = '/favorecidos',
    'Ordens Fornecimento' = '/compras',
    'Requisição de compras' = '/rcms',
    'Parâmetros do compra' = '/parametros-compra',
    'Prazos' = '/prazos',
    'Produtos' = '/produtos',
    'Serviços' = '/servicos',
    'Indices Banco Preço' = '/indices-banco-preco',

    'Bens Móveis' = '/tombamentos',
    'Bens Imóveis' = '/imoveis',
    'Baixas' = '/baixas-patrimonio',
    'Motivos de Baixas' = '/motivos-baixas-patrimonio',
    'Parâmetros' = '/parametros-patrimonio',
    'Tipos de Ocorrências' = '/tipos-imoveis-ocorrencia',
    'Tipos de Transferências' = '/tipos-transferencias-patrimonio',
    'Manutenções' = '/manutencoes-patrimonio',
    'Transferências' = '/transferencias-patrimonio',
    'Inventários' = '/Inventário',

    'Diário Oficial' = '/diario-oficial',
    'Seções' = '/secoes',
    'Subseções' = '/subsecoes',
    'Feriados' = '/feriados',

    'Vereadores' = '/vereadores',
    'Partidos' = '/partidos',
    'Ritos' = '/ritos',
    'Quóruns' = '/quoruns',
    'Votação - Turnos' = '/votacao-turnos',
    'Votação - Tipos' = '/votacao-tipos',
    'Expediêntes' = '/expedientes',
    'Votação - Resultados' = '/votacao-resultados',
    'Legislação - Tipos' = '/legislacao-tipos',

    'Estatísticas' = '/estatisticas',
    'Assuntos' = '/assuntos',
    'Cidadãos' = '/cidadaos',
    'Protocolo - Agendamentos' = '/protocolo/agendamentos',
    'Protocolo - cidadão' = '/protocolo-cidadao',
    'Protocolo - Ajuda' = '/protocolo/ajuda',

    'Chamamentos' = '/chamamentos',
    'Credenciamentos' = '/credenciamentos',
    'Prestação de Contas' = '/prestacao-contas',
    'Solicitação de Credenciamento' = '/credenciamento-solicitacao',
    'Convênios' = '/convenios',
    'Modelos' = '/modelos',
    'Parâmetros do Terceiro Setor' = '/parametros-terceiro-setor',

    'Portal da Entidade' = '/portal-entidade',

    'Cargos' = '/cargos',
    'Departamentos' = '/departamentos',
    'Funcionários' = '/funcionarios',
    'Holerites' = '/holerites',

    'Metas de governo' = '/metas-governo',
    'Ações do governo' = '/acoes-governo',
    'Adiantamentos' = '/adiantamentos',
    'Empenhos Orçamentários' = '/empenhos',
    'Empenhos Extra-orçamentários' = '/empenhos-extra',
    'Empenhos de Restos' = '/empenhos-resto',
    'Liquidações Orçamentárias' = '/liquidacoes',
    'Liquidações de Restos' = '/liquidacoes-restos-pagar',
    'Balancetes' = '/balancetes',
    'Anexos LRF' = '/anexos-lrf',
    'Quadros de ensino' = '/quadros-ensino',
    'Quadros da saúde' = '/quadros-saude',
    'Recebimentos' = '/recebimentos',
    'Recebimentos Extra-orçamentários' = '/recebimentos-extras',
    'Pagamentos' = '/pagamentos',
    'Pagamentos Extra-orçamentários' = '/pagamentos-extras',
    'Pagamentos de Restos' = '/pagamentos-restos-pagar',
    'Transferências Bancárias' = '/transferencias-bancarias',
    'Planos Plurianuais' = '/planos-plurianuais',
    'Audiências públicas' = '/audiencias-publica',
    'Unidades' = '/unidades',
    'Fontes de Financiamento' = '/fontes-financiamento',
    'Receitas Orçamentárias' = '/receitas-orcamentaria',
    'Despesas Orçamentárias' = '/despesas-orcamentaria',
    'LDO' = '/ldo',
    'Anexos PPA' = '/anexos-ppa',
    'Anexos LDO' = '/anexos-ldo',
    'Fichas de Receita' = '/fichas-receita',
    'Receitas Previstas' = '/receitas-prevista',
    'Fichas de Despesa' = '/fichas-despesa',
    'Despesas Previstas' = '/despesas-prevista',
    'Despesas por Função' = '/despesa-funcao',
    'Movimentação de Materiais' = '/movimentacao',
    'Transferências Previstas' = '/transferencias-prevista',
    'Créditos Adicionais' = '/creditos',
    'Reservas de dotação' = '/reservas-dotacao',
    'Anexos LOA' = '/anexos-loa',
    'Plano de Contas' = '/plano-contas',
    'Fichas Extras' = '/fichas-extra',
    'Variações' = '/variacoes',
    'Eventos Contábeis' = '/eventos-contabeis',
    'Balanços' = '/balancos',
    'Razonetes' = '/razonetes',
    'Matriz de Saldos Contábeis' = '/matriz-saldos-contabeis',
    'Contas bancárias' = '/contas-bancarias',
    'AUDESP' = '/audesp-contabil',
    'AUDESP (layouts)' = '/layout-audesp',
    'Órdens de Pagamento (OP)' = '/ordens-pagamento',
    'Relatórios da Tesouraria' = '/relatorios-tesouraria',
    'Paramêtros Contábil' = '/parametros-contabil',
    'Ações' = '/acoes',
    'Programas' = '/programas',
    'Funções do governo' = '/funcoes-governo',
    'Recursos' = '/recursos',
    'Aplicação de Recursos' = '/aplicacao-recursos',
    'Tipo de Favorecidos' = '/favorecidos-tipos',
    'Precatórios' = '/precatorios',
    'Cheques Layout' = '/cheques-layout',
    'Grupos da Receita' = '/grupos-receita',
    'PASEP' = '/pasep',
    'Retenções IRRF' = '/retencoes-irrf',
    'Planejamento' = '/planejamento',
    'Portal Contabilidade' = "/contabilidade",

    'Parâmetros da transparência' = '/admin/transparencia/parametros-transparencia',
    'Atas de Registro de Preços - Anexo' = '/admin/transparencia/atas-registro-anexos',
    'Anexos de Empenhos Orçamentários' = '/admin/transparencia/empenhos-orcamentarios-anexos',
    'Anexos de Contratos e Aditivos' = '/admin/transparencia/contratos-anexos',
    'Anexos de Licitação' = '/admin/transparencia/licitacoes-anexos',
    'Eventos (Holerite)' = '/admin/transparencia/eventos-holerite',

    'Previsão de Receitas' = '/receitas-previstas',
    'Previsão de Despesas' = '/despesas-previstas',
    'Despesas Empenhadas Mensais' = '/despesa-nivel',
    'Remuneração Servidores' = '/remuneracao-servidores',

    'Modalidades' = '/modalidades',
    'Tipos de Contratação' = '/tipos-contratacao',
    'Comissões' = '/comissoes',
    'Licitações' = '/licitacoes',
    'Pregões' = '/pregoes',
    'Audesp Fase 4' = '/licitacoes-audesp',

    'Combustíveis' = '/combustiveis',
    'Motoristas' = '/motoristas',
    'Óleos' = '/oleos',
    'Pneus' = '/pneus',
    'Portarias' = '/portarias',
    'Postos de Abastecimento' = '/postos-abastecimento',
    'Tipos de Veículo' = '/tipos-veiculo',
    'Veículos' = '/veiculos',
    'Abastecimentos' = '/abastecimentos',
    'Manutenções Preventivas' = '/manutencoes-preventivas',
    'Ordens de Serviço' = '/ordens-servico',
    'Viagens' = '/viagens',
    'Relatório de Abastecimento' = '/abastecimentos-relatorio',
    'Relatório de Manutenção' = '/manutencao-relatorio',
    'Relatório de Manutenção preventiva' = '/manutencoes-preventivas',
    'Relatório de Motorista' = '/motoristas-relatorio',
    'Relatório de Multas' = '/multas-relatorio',
    'Relatório de Pontuação de motoristas' = '/pontuacoes-motorista',
    'Relatório de Vencimentos de CNH' = '/vencimentos-cnh',
    'Relatório de Vencimento de CRLV' = '/vencimentos-crlv',
    'Gráfico de gasto - consumo' = '/abastecimentos-estatistica',
    'Gráfico de gasto - manutenção' = '/manutencoes-estatistica',
}

interface ISistemas {
    paginas(): string[];
}

export class ComumPag implements ISistemas {
    paginas() {
        return [
            'Órgãos',
            'Usuários',
            'Setores',
            'Agendamentos',
            'Parâmetros de E-mail',
            'Relatórios Personalizados',
            'Exercícios',
            'Assinaturas',
        ];
    }
}
export class AlmoxarifadoPag implements ISistemas {
    paginas() {
        return [
            'Estoques',
            'Grupos de Estoque',
            'Unidades de Fornecimento',
            'Subgrupos de Estoque',
            'Materiais',
            'Entradas',
            'Saídas',
        ];
    }
}

export class ControleInternoPag implements ISistemas {
    paginas() {
        return [
            'Processos',
            'Fiscalizações',
            'Questionários',
            'Auditoria de Empenhos',
            'Auditoria de Adiantamentos',
            'Auditoria de Contratos',
            'Auditoria de Licitações',
            'Auditoria de Avaliações',
            'Auditoria de Patrimônios',
            'Audesp-TCE-SP'
        ];
    }
}

export class CompraPag implements ISistemas {
    paginas() {
        return [
            'Contratos',
            'Licitações',
            'Favorecidos',
            'Ordens Fornecimento',
            'Parâmetros do compra',
            'Produtos',
            'Serviços',
            'Prazos'
        ];
    }
}

export class PatrimonioPag implements ISistemas {
    paginas() {
        return [
            'Bens Móveis',
            'Bens Imóveis',
            'Baixas',
            'Motivos de Baixas',
            'Parâmetros',
            'Tipos de Ocorrências',
            'Tipos de Transferências',
            'Manutenções',
            'Transferências',
            'Inventários',
        ];
    }
}

export class DiarioOficialPag implements ISistemas {
    paginas() {
        return [
            'Diário Oficial',
            'Seções',
            'Subseções',
            'Feriados'
        ];
    }
}
export class LegislativoPag implements ISistemas {
    paginas() {
        return [
            'Vereadores',
            'Partidos',
            'Ritos',
            'Quóruns',
            'Votação - Turnos',
            'Votação - Tipos',
            'Expediêntes',
            'Votação - Resultados',
            'Legislação - Tipos',
        ];
    }
}

export class ProtocoloPag implements ISistemas {
    paginas() {
        return [
            'Estatísticas',
            'Assuntos',
            'Cidadãos',
            'Protocolo - Agendamentos',
            'Protocolo - cidadão',
            'Protocolo - Ajuda',
        ];
    }
}

export class FolhaPag implements ISistemas {
    paginas() {
        return [
            'Cargos',
            'Departamentos',
            'Funcionários',
            'Holerites',
        ];
    }
}

export class TerceiroSetorPag implements ISistemas {
    paginas() {
        return [
            'Chamamentos',
            'Credenciamentos',
            'Prestação de Contas',
            'Solicitação de Credenciamento',
            'Convênios',
            'Modelos',
            'Parâmetros do Terceiro Setor',
        ];
    }
}

export class PortalEntidadePag implements ISistemas {
    paginas() {
        return [
            'Chamamentos',
            'Credenciamentos',
            'Prestação de Contas',
            'Solicitação de Credenciamento',
            'Convênios',
            'Modelos',
            'Parâmetros do Terceiro Setor',
            'Portal da Entidade'
        ];
    }
}

export class PlanejamentoPag implements ISistemas {
    paginas() {
        return [
            'Planejamento',
            'Planos Plurianuais',
            'Audiências públicas',
            'Unidades',
            'Fontes de Financiamento',
            'Metas de governo',
            'Ações do governo',
            'LDO',
            'Anexos PPA',
            'Anexos LDO',
            'Receitas Orçamentárias',
            'Despesas Orçamentárias',
            'Fichas de Receita',
            'Receitas Previstas',
            'Fichas de Despesa',
            'Despesas Previstas',
            'Movimentação de Materiais',
            'Despesas por Função',
            'Transferências Previstas',
            'Créditos Adicionais',
            'Reservas de dotação',
            'Anexos LOA',
        ];
    }
}

export class TesourariaPag implements ISistemas {
    paginas() {
        return [
            'Transferências Bancárias',
            'Contas bancárias',
            'Órdens de Pagamento (OP)',
            'Relatórios da Tesouraria',
            'Recebimentos',
            'Recebimentos Extra-orçamentários',
            'Pagamentos',
            'Pagamentos Extra-orçamentários',
            'Pagamentos de Restos',
        ];
    }
}

export class ContabilidadePag implements ISistemas {
    paginas() {
        return [
            'Portal Contabilidade',
            'Adiantamentos',
            'Empenhos Orçamentários',
            'Empenhos Extra-orçamentários',
            'Empenhos de Restos',
            'Liquidações Orçamentárias',
            'Liquidações de Restos',
            'Balancetes',
            'Anexos LRF',
            'Quadros de ensino',
            'Quadros da saúde',
            'Plano de Contas',
            'Fichas Extras',
            'Variações',
            'Eventos Contábeis',
            'Balanços',
            'Razonetes',
            'Matriz de Saldos Contábeis',
            'AUDESP',
            'AUDESP (layouts)',
            'Paramêtros Contábil',
            'Ações',
            'Programas',
            'Funções do governo',
            'Recursos',
            'Aplicação de Recursos',
            'Tipo de Favorecidos',
            'Precatórios',
            'Cheques Layout',
            'Grupos da Receita',
            'PASEP',
            'Retenções IRRF',
        ];
    }
}
export class TransparenciaPag implements ISistemas {
    paginas() {
        return [
            'Parâmetros da transparência',
            'Atas de Registro de Preços - Anexo',
            'Anexos de Empenhos Orçamentários',
            'Anexos de Contratos e Aditivos',
            'Anexos de Licitação',
            'Eventos (Holerite)',
        ];
    }
}
export class LicitacaoPag implements ISistemas {
    paginas() {
        return [
            "Modalidades",
            "Tipos de Contratação",
            "Comissões",
            "Unidades",
            "Licitações",
            "Pregões",
            "Audesp Fase 4",
            "Contratos",
            "Favorecidos",
            "Ordens Fornecimento",
        ];
    }
}
export class FrotaPag implements ISistemas {
    paginas() {
        return [
            'Combustíveis',
            'Motoristas',
            'Óleos',
            'Pneus',
            'Portarias',
            'Postos de Abastecimento',
            'Tipos de Veículo',
            'Veículos',
            'Abastecimentos',
            'Manutenções Preventivas',
            'Ordens de Serviço',
            'Viagens',
            'Relatório de Abastecimento',
            'Relatório de Manutenção',
            'Relatório de Manutenção preventiva',
            'Relatório de Motorista',
            'Relatório de Multas',
            'Relatório de Pontuação de motoristas',
            'Relatório de Vencimentos de CNH',
            'Relatório de Vencimento de CRLV',
            'Gráfico de gasto - consumo',
            'Gráfico de gasto - manutenção',
        ];
    }
}

